export const USER_LOGIN = "USER_LOGIN";
export const PUBLIC_IP = "PUBLIC_IP";